import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from "ngx-spinner";

import { LoginService } from '../services/login.service';
import { DashboardService } from '../services/dashboard.service';

@Component({
    selector: 'app-projects',
    templateUrl: './projects.component.html',
    styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {

    public session_data: any = {};
    public err: any = {};
    public result: any = {};
    public projects = [];
    public form: any = {};
    public search_term = '';

    public page: number = 1;
    public page_length: number = 10;
    public total: number = 0;

    public order_by = 1;
    public table_options = ['desc', 'desc'];

    constructor(private router: Router, public fb: FormBuilder, private service: DashboardService, private login: LoginService, private spinner: NgxSpinnerService) {
        this.session_data.id = login.get_session_data('ieye_session_id');
        this.session_data.role = login.get_session_data('ieye_session_role');
        this.service.setTitle('Projects | 24ieye');

        this.form = this.fb.group({
            user_id: [''],
        });
    }

    ngOnInit(): void {
        this.get_projects();
    }

    public pageChanged(page) {
        this.page = page;
        this.get_projects();
    }

    public data_order_by(column) {
        this.page = 1;
        this.table_options[column] = this.table_options[column] == 'asc' ? 'desc' : 'asc';
        this.order_by = column;
        this.get_projects();
    }

    public hold_project(id) {
        Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Hold!'
        }).then((action) => {
            if (action.isConfirmed) {
                this.hold_actions(id, 'hold_project');
            }
        });
    }

    public unhold_project(id) {
        Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Unhold!'
        }).then((action) => {
            if (action.isConfirmed) {
                this.hold_actions(id, 'unhold_project');
            }
        });
    }

    public project_search() {
        this.search_term = (<HTMLInputElement>document.getElementById('search_term')).value;
        this.get_projects();
    }

    public async get_projects() {
        this.spinner.show();
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("search", this.search_term);
        formData.append("order[column]", this.order_by);
        formData.append("order[dir]", this.table_options[this.order_by]);
        this.result = await this.service.form_actions(formData, 'projects');
        if (this.result.status == false) {
            this.spinner.hide();
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.projects = this.result.data;
            this.spinner.hide();
        }
    }

    public delete_project(id) {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((action) => {
            if (action.isConfirmed) {
                this.delete_actions(id);
            }
        });
    }

    public async delete_actions(id) {
        this.spinner.show();
        var formData: any = new FormData();
        formData.append("id", id);
        this.result = await this.service.form_actions(formData, 'delete_project');

        if (this.result.status == true) {
            this.spinner.hide();
            Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 })
            this.router.routeReuseStrategy.shouldReuseRoute = function() {
                return false;
            }
            this.router.onSameUrlNavigation = 'reload';
            setTimeout(() => {
                this.router.navigate(['projects']);
            }, 1000);
        } else {
            this.spinner.hide();
            Swal.fire('Alert!', this.result.message, 'error');
        }
    }

    public async hold_actions(id, slug) {
        this.spinner.show();
        var formData: any = new FormData();
        formData.append("id", id);
        this.result = await this.service.form_actions(formData, slug);

        if (this.result.status == true) {
            this.spinner.hide();
            Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 });
            this.get_projects();
        } else {
            this.spinner.hide();
            Swal.fire('Alert!', this.result.message, 'error');
        }
    }

}
